import { useEffect, useRef, useState } from "react";

// Animated count-up. Eases from 0 to `value` on mount (and when value changes).
export default function CountUp({ value = 0, decimals = 0, prefix = "", suffix = "", duration = 1100, className }) {
  const [display, setDisplay] = useState(0);
  const raf = useRef(null);
  const target = Number(value) || 0;

  useEffect(() => {
    const start = performance.now();
    const from = 0;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setDisplay(from + (target - from) * eased);
      if (p < 1) raf.current = requestAnimationFrame(tick);
      else setDisplay(target);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration]);

  const formatted = display.toLocaleString("it-IT", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return <span className={className}>{prefix}{formatted}{suffix}</span>;
}
